import getWindowVenues from '../helpers/getWindowVenues'
import { Action, ActionType, BookingInfo } from '../model/model'
import createReducer from './createReducer'

const windowVenues = getWindowVenues()

const initialState = {
  confirms: 0,
  customerPending: 0,
  hotelPending: 0,
  futureConfirms: 0,
  futureCustomerPending: 0,
  futureHotelPending: 0,
  venues:
    process.env.NODE_ENV === 'production'
      ? windowVenues
      : [
          {
            vid: '25465',
            name: 'MP test'
          },
          {
            vid: '79137',
            name: 'Matin Palatsidd'
          },
          { vid: '79684', name: 'Quality Hotel Friends Test' },
          { vid: '215010', name: 'CWT testjlj' }
        ],
  confirmedBookingValue: null,
  confirmedBookingValueSupport: null,
  unconfirmedBookingValue: null,
  unconfirmedBookingValueSupport: null,
  totalBookings: null,
  totalBookingsSupport: null,
  successBookingRate: null,
  revenueEarned: null,
  canceledBookings: null,
  canceledBookingsSupport: null,
  canceledReasons: [],
  bookingSources: [],
  orders: [],
  sourceOfWebsite: [],
  numberOfEvents: 0,
  latestUpdatedOrders: [],
  isLoading: false,
  error: null
}

export const bookingInfo = createReducer(initialState, {
  [ActionType.FETCH_BOOKINGINFO_SUCCESS](
    state: BookingInfo,
    action: Action<BookingInfo>
  ) {
    return { ...state, ...action.payload, isLoading: false }
  },

  [ActionType.FETCHING_BOOKINGINFO](state: BookingInfo) {
    return { ...state, isLoading: true }
  },

  [ActionType.FETCH_BOOKINGINFO_FAIL](state: BookingInfo, action: Action<any>) {
    return { ...state, error: action.payload, isLoading: false }
  }
})
